export default "__VITE_ASSET__f04e31b3__"